import React, { Component, Fragment } from 'react';
import { I18n } from 'aws-amplify';
import { Link, Redirect } from 'react-router-dom';
import {
    Row,
    Col,
    Button,
    Avatar
} from 'antd';
import ContainerPage from './ContainerPage';
import styled from 'styled-components';

class HeaderThumbCover extends Component {
    state = {}
    render() {
        const { thumb, bgHeader, isCreative = false, title = "", link } = this.props;

        const TitleButton = styled.header`
            background: #fff;
            height: 90px;


            h3 {
                line-height: 90px;
                font-weight: 600;
            }

            .btEditar {
                float: right;
                margin-top: 30px;
            }
            `;

        const BannerCover = styled.div`
            background: #ccc url(${bgHeader});
            background-size: cover;
            height: 220px;

            .LogoAvatar {
                background: #fff;
                position: relative;
                top: 110px;
                left: 70px;

                @media (max-width: 768px) {
                    left: 0px;
                    display: block;
                    margin: 0 auto;
                }
            }
        `;

        return (
            <Fragment>
                <header>
                    {link &&
                        <TitleButton>
                            <ContainerPage>
                                <Row>
                                    <Col sm={22}>
                                        <h3>{title}</h3>
                                    </Col>

                                    <Col sm={2}>
                                        <Link to={link}>
                                            <Button type="primary" shape="round" size="large" className="btEditar">Editar</Button>
                                        </Link>
                                    </Col>
                                </Row>
                            </ContainerPage>
                        </TitleButton>
                    }
                    <BannerCover
                        style={{ backgroundImage: bgHeader ? bgHeader : "" }}
                    >
                        <ContainerPage>
                            <Avatar className="LogoAvatar" size={205} icon="user" src={thumb ? thumb : "https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png"} />
                        </ContainerPage>
                    </BannerCover>
                </header>
            </Fragment>
        );
    }
}


export default HeaderThumbCover;
